import { PageId } from 'records/Page';
import { RFI } from 'records/RFI';
import { SheetId } from 'records/Sheet';

class RFIPost {
  rfi: RFI;

  sheetid: SheetId;

  pageid: PageId;

  constructor(rfi: RFI, sheetid: SheetId, pageid: PageId) {
    this.rfi = rfi;
    this.sheetid = sheetid;
    this.pageid = pageid;
  }
}

export default RFIPost;
